import { render, staticRenderFns } from "./Merkliste.vue?vue&type=template&id=369f2712"
import script from "./Merkliste.vue?vue&type=script&lang=js"
export * from "./Merkliste.vue?vue&type=script&lang=js"
import style0 from "./Merkliste.vue?vue&type=style&index=0&id=369f2712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports